import { createFileRoute } from '@tanstack/react-router'
import ConceptGeneral from 'Concept/components/Concept/Sections/ConceptGeneral'

import { Guard } from '../../-guard'

export const Route = createFileRoute('/concept/$conceptId/general')({
    component: () => (
        <Guard features={['profitability']}>
            <ConceptGeneral />
        </Guard>
    ),
})
